import { Typography, Grid, Box, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import UsersFilter from "./UsersFilter";
import UserProfileCard from "./UserProfileCard";
import { Pagination } from "./styled";
import { User } from "../UserProfile/types";
import { useTheme } from "@mui/material/styles";
import { useRouter } from "next/router";
import UserSearchBar from "./UserSearchBar";
import { getPageFromUrl } from "@js/util/urlUtil";
import { UsersProps } from "./types";

const Users = (props: UsersProps) => {
    const router = useRouter();
    const { users, totalPages } = props;

    // current page user is viewing
    const [currentPage, setCurrentPage] = useState(1);
    // search term to find users by (alias or address)
    const [userSearch, setUserSearch] = useState<string>(
        router.query.search as string
    );

    // effect used to grab the URL parameters to setup initial state
    useEffect(() => {
        const pageNum = getPageFromUrl();
        setCurrentPage(pageNum + 1);
    }, []);

    /**
     * @param event an event object
     * @param value new page number
     * Changes/Paginates to a new page
     */
    const handleChangePage = (event: any, value: number) => {
        setCurrentPage(value);
        let historyurl: string = `/users?search=${userSearch}&page=${
            value - 1
        }`;
        router.push(historyurl);
    };

    // Hook that returns theme object for use in function component
    const theme = useTheme();

    return (
        <Container
            maxWidth="xl"
            sx={{ p: 3, backgroundColor: theme.palette.background.paper }}
        >
            <Grid container direction="row" rowSpacing={2}>
                <Grid item md={12} lg={12} xl={12}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: "bold",
                            fontSize: "20px",
                            lineHeight: "23px",
                        }}
                    >
                        Community
                    </Typography>
                </Grid>
                <Grid
                    container
                    item
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    <Grid item md={5} lg={4} xl={4}>
                        <UsersFilter />
                    </Grid>
                    <UserSearchBar setUserSearch={setUserSearch} />
                </Grid>
            </Grid>
            <Grid container alignItems="baseline" rowSpacing={3} p="32px 0">
                {users.map((user: User, index: number) => {
                    return (
                        <Grid
                            item
                            key={index}
                            md={4}
                            lg={3}
                            xl={3}
                            textAlign="center"
                        >
                            <UserProfileCard user={user} />
                        </Grid>
                    );
                })}
            </Grid>
            <Box>
                <Pagination
                    count={totalPages}
                    shape="rounded"
                    onChange={handleChangePage}
                    page={currentPage}
                />
            </Box>
        </Container>
    );
};

export default Users;
